import React from 'react';
import DivContainerBody from '../../../../../../../components/DivContainerBody';
import HeadTittle from '../../../../../../../components/HeadTittle';
import ButtonAction from '../../../../../../../components/buttons/ButtonAction';
import {AddIcon, EditIcon} from '../../../../../../../components/buttons/IconButtons';
import DividerWithText from '../../../../../../../components/DividerWithText';
import UpdatePolicyGroupApp from "./Functionality/UpdatePolicyGroupApp";
import PolicyDetails from "../../Global/CreateUpdatePolicy/SubComponents/PolicyDetails";
import RuleForm from "../../Global/CreateUpdatePolicy/SubComponents/RuleForm";
import CommonPolicyApp from "../../Global/CreateUpdatePolicy/Functionality/CommonPolicyApp";
import RulesTable from "../../Global/CreateUpdatePolicy/SubComponents/RulesTable";
import DeleteModal from '../../../../../../Modals/DeleteModal';


/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 */
const UpdatePolicyGroup = ({ disabled }) => {
    const {
        t,
        navigate,
        isGlobal,
        item,
        setItem,
        handleChange,
        emptyFields,
        setEmptyFields,
        departments,
        setDepartments,
        handleReorderRules,
        goBack,
        rule,
        setRule,
        updateRuleField,
        ruleEmptyFields,
        setRuleEmptyFields,
        ruleIsValid,
        ruleIsValidCalculationValue,
        ruleIsValidCalculationValueText,
        handleAddRule,
        handleDeleteRule,
        confirmDeleteRule,
        showDeleteModal,
        setShowDeleteModal,
        selectedItem,
        setSelectedItem,
        isRuleFormValid
    } = CommonPolicyApp();

    const {
        handleUpdate,
    } = UpdatePolicyGroupApp({
        t,
        item,
        setItem,
        rule,
        setRule,
        departments,
        setDepartments,
        navigate,
        isGlobal,
        setEmptyFields,
        goBack,
        setRuleEmptyFields
    });

    return (
        <>
            <HeadTittle onBack={goBack} name={disabled ? 'details' : 'update'}>
                { !disabled &&
                    <ButtonAction
                        id='btn_upg_update'
                        name='update'
                        Icon={EditIcon}
                        className='btn-icon-edit'
                        onClick={handleUpdate}
                    />
                }
            </HeadTittle>
            <DivContainerBody>
                <div className={"mt-4 mb-60px"}>
                    <PolicyDetails
                        item={item}
                        setItem={setItem}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                        selectedList={departments}
                        setSelectedList={setDepartments}
                        disabled={disabled}
                    />
                    <DividerWithText title={t('rule_conditions')} spacing={'my-4'} />

                    {!disabled &&
                        <>
                            <RuleForm
                                rule={rule}
                                updateRuleField={updateRuleField}
                                emptyFields={ruleEmptyFields}
                                isGlobal={isGlobal}
                                isValid={ruleIsValid}
                                isValidCalculationValue={ruleIsValidCalculationValue}
                                isValidCalculationValueText={ruleIsValidCalculationValueText}
                                disabled={disabled}
                            />
                            <div className='col-12 d-flex justify-content-end'>
                                <ButtonAction
                                    id='btn_upg_add_rule'
                                    name='add_new_rule'
                                    Icon={AddIcon}
                                    className='btn-secondary-600'
                                    onClick={handleAddRule}
                                    splitName={false}
                                    disabled={!isRuleFormValid()}
                                />
                            </div>
                        </>
                    }

                    { item.rules?.length > 0 &&
                        <div className={"border-full-shades-300 border-radius-8px mt-4 p-3"}>
                            <RulesTable
                                rules={item.rules}
                                isGlobal={isGlobal}
                                sortable={!disabled}
                                onDragEnd={disabled ? undefined : handleReorderRules}
                                onDeleteRule={disabled ? undefined : handleDeleteRule}
                            />
                        </div>
                    }
                </div>
            </DivContainerBody>
            <DeleteModal
                show={showDeleteModal}
                onHide={() => {
                    setShowDeleteModal(false);
                    setSelectedItem(null);
                }}
                onClickFn={confirmDeleteRule}
                title_modal="delete_rule"
                data={[selectedItem]}
                element_modal="rule"
            />
        </>
    );
};

export default UpdatePolicyGroup;
